/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const challengeExampleSchema = z.object({
  id: z.number(),
  text: z.string(),
  highlight: z.tuple([z.number(), z.number()]),
  context: z.string().optional(),
  difficulty: z.string().optional(),
});

export type IChallengeExample = z.infer<typeof challengeExampleSchema>;
